export const defaultEntity = "autori";
export const entities = ["autori"];
export const labels = {
  autori: "Autori",
};
